export const tinTucArticles = [
  {
    id: 1,
    title: 'Phương pháp học tập hiệu quả cho học sinh THCS',
    excerpt: 'Khám phá những phương pháp học tập khoa học giúp học sinh cấp 2 nắm vững kiến thức và đạt kết quả cao trong học tập.',
    category: 'Phương pháp học',
    image: 'https://public.readdy.ai/ai/img_res/9cfefe4235672cc87cd4c946ae7b7204.jpg',
    date: '15/01/2025',
    views: 1250,
    readTime: 8,
  },
  {
    id: 2,
    title: 'Tiểu Sử Cầu Thủ Đình Bắc - Từ Niềm Đam Mê Đến Sự Nghiệp Bóng Đá',
    excerpt: 'Hành trình từ một cậu bé yêu bóng đá đến cầu thủ chuyên nghiệp của Đình Bắc - câu chuyện truyền cảm hứng cho thế hệ trẻ theo đuổi ước mơ.',
    category: 'Thể thao',
    image: 'https://readdy.ai/api/search-image?query=young%20vietnamese%20football%20soccer%20player%20in%20red%20jersey%20training%20on%20grass%20field%20with%20determined%20expression%20bright%20morning%20sunlight%20simple%20clean%20background%20sports%20photography%20professional%20athlete%20portrait&width=800&height=500&seq=dinhbac001&orientation=landscape',
    date: '15/01/2025',
    views: 850,
    readTime: 10,
  },
  {
    id: 3,
    title: 'Cập nhật chương trình SGK mới năm 2025',
    excerpt: 'Tổng hợp những thay đổi quan trọng trong chương trình sách giáo khoa mới, giúp phụ huynh và học sinh nắm bắt kịp thời.',
    category: 'Tin giáo dục',
    image: 'https://readdy.ai/api/search-image?query=new%20textbooks%20curriculum%20educational%20materials%20books%20desk%20organized%20school%20supplies%20modern%20clean%20background%20bright%20lighting&width=800&height=500&seq=news-sgk-002&orientation=landscape',
    date: '12/01/2025',
    views: 2100,
    readTime: 6,
  },
  {
    id: 4,
    title: 'Mẹo ghi nhớ công thức Toán - Lý - Hóa nhanh',
    excerpt: 'Những kỹ thuật ghi nhớ hiệu quả giúp học sinh nhớ lâu các công thức quan trọng trong các môn tự nhiên.',
    category: 'Mẹo học tập',
    image: 'https://readdy.ai/api/search-image?query=mathematical%20formulas%20chemistry%20equations%20physics%20notes%20colorful%20mind%20map%20memory%20techniques%20study%20aids%20bright%20educational%20illustration&width=800&height=500&seq=news-memo-003&orientation=landscape',
    date: '10/01/2025',
    views: 3400,
    readTime: 10,
  },
  {
    id: 5,
    title: 'Lịch thi THPT Quốc gia 2025 chính thức',
    excerpt: 'Bộ Giáo dục công bố lịch thi chính thức kỳ thi THPT Quốc gia năm 2025 cùng những lưu ý quan trọng cho thí sinh.',
    category: 'Tin thi cử',
    image: 'https://readdy.ai/api/search-image?query=examination%20hall%20students%20taking%20test%20official%20exam%20scene%20focused%20students%20calendar%20schedule%20educational%20setting%20serious%20atmosphere&width=800&height=500&seq=news-exam-004&orientation=landscape',
    date: '08/01/2025',
    views: 5200,
    readTime: 5,
  },
  {
    id: 6,
    title: 'Phân tích đề thi Văn THPT 2024 - Xu hướng ra đề',
    excerpt: 'Đánh giá chi tiết đề thi môn Văn năm 2024 và dự đoán xu hướng ra đề trong các kỳ thi sắp tới.',
    category: 'Phân tích đề thi',
    image: 'https://readdy.ai/api/search-image?query=vietnamese%20literature%20exam%20papers%20analysis%20documents%20pen%20highlighter%20study%20desk%20organized%20workspace%20professional%20educational%20setting&width=800&height=500&seq=news-van-005&orientation=landscape',
    date: '05/01/2025',
    views: 1800,
    readTime: 12,
  },
  {
    id: 7,
    title: 'Top 10 trường THPT có điểm chuẩn cao nhất 2024',
    excerpt: 'Bảng xếp hạng các trường THPT có điểm chuẩn đầu vào cao nhất cả nước, cùng phân tích xu hướng tuyển sinh.',
    category: 'Xếp hạng',
    image: 'https://readdy.ai/api/search-image?query=school%20building%20modern%20architecture%20education%20institution%20ranking%20trophy%20award%20educational%20excellence%20asian%20school%20campus&width=800&height=500&seq=news-rank-006&orientation=landscape',
    date: '03/01/2025',
    views: 4500,
    readTime: 7,
  },
  {
    id: 8,
    title: 'Hướng dẫn làm bài thi trắc nghiệm đạt điểm cao',
    excerpt: 'Chiến lược làm bài trắc nghiệm thông minh, quản lý thời gian hiệu quả và tránh những sai lầm phổ biến.',
    category: 'Kỹ năng thi cử',
    image: 'https://readdy.ai/api/search-image?query=multiple%20choice%20answer%20sheet%20pencil%20bubble%20test%20strategy%20timing%20clock%20focused%20student%20hand%20marking%20answers%20educational%20scene&width=800&height=500&seq=news-skill-007&orientation=landscape',
    date: '01/01/2025',
    views: 2900,
    readTime: 9,
  },
  {
    id: 9,
    title: 'Xu hướng giáo dục STEM tại Việt Nam 2025',
    excerpt: 'Tìm hiểu về xu hướng giáo dục STEM đang được áp dụng rộng rãi và tầm quan trọng của nó đối với học sinh.',
    category: 'Xu hướng giáo dục',
    image: 'https://readdy.ai/api/search-image?query=STEM%20education%20science%20technology%20engineering%20math%20robot%20laboratory%20students%20experiment%20modern%20classroom%20innovation%20asian%20students&width=800&height=500&seq=news-stem-008&orientation=landscape',
    date: '28/12/2024',
    views: 1600,
    readTime: 11,
  },
  {
    id: 10,
    title: 'Cách chuẩn bị tốt cho kỳ thi học kỳ',
    excerpt: 'Lộ trình ôn tập chi tiết và các mẹo chuẩn bị hiệu quả giúp học sinh tự tin bước vào kỳ thi học kỳ.',
    category: 'Cẩm nang thi cử',
    image: 'https://readdy.ai/api/search-image?query=student%20preparing%20exam%20study%20plan%20notebook%20planner%20organized%20schedule%20desk%20lamp%20books%20motivation%20studying%20asian%20student%20concentrated&width=800&height=500&seq=news-prep-009&orientation=landscape',
    date: '25/12/2024',
    views: 3100,
    readTime: 10,
  },
];
